"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schedule = void 0;
class Schedule {
    constructor(delay = 0, maxEmissions = -1, resetUpdatesAfter = -1) {
        this.delay = delay;
        this.maxEmissions = maxEmissions;
        this.resetUpdatesAfter = resetUpdatesAfter;
        this.updateCount = 0;
        this.emissionCount = 0;
    }
    static Every(interval, maxEmissions = -1) {
        return new Schedule(interval, maxEmissions, -1);
    }
    static Once() {
        return new Schedule(0, 1);
    }
    static Delayed(count) {
        return new Schedule(count);
    }
    static LimitedEmissions(maxEmissions) {
        return new Schedule(0, maxEmissions);
    }
    static Combined(delay, maxEmissions) {
        return new Schedule(delay, maxEmissions);
    }
    static ready(schedule) {
        return schedule.updateCount >= schedule.delay;
    }
    static expired(schedule) {
        return schedule.maxEmissions >= 0
            && schedule.emissionCount >= schedule.maxEmissions;
    }
    static update(schedule) {
        schedule.updateCount += 1;
    }
    static emit(schedule) {
        schedule.emissionCount += 1;
        if (schedule.emissionCount >= schedule.resetUpdatesAfter) {
            schedule.updateCount = 0;
        }
    }
}
exports.Schedule = Schedule;
Schedule.Unlimited = new Schedule();
